import { render } from "./BankDialog.vue?vue&type=template&id=fb505692&scoped=true&ts=true"
import script from "./BankDialog.vue?vue&type=script&lang=ts"
export * from "./BankDialog.vue?vue&type=script&lang=ts"

import "./BankDialog.vue?vue&type=style&index=0&id=fb505692&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb505692"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInput,QInnerLoading,QSpinner,QSeparator});
